import React, { useEffect, useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { serratedTabsStylesHook } from '@mui-treasury/styles/tabs';

import { StateContext, DispatchContext } from '../../../../context/Provider';

const SerratedTabs = (props) => {

    const classcode = props.classcode;
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { globalState, authState } = appState;
    const { globalDispatch } = appDispatch;

    // const [tabIndex, setTabIndex] = useState(0);
    const tabsStyles = serratedTabsStylesHook.useTabs();
    const tabItemStyles = serratedTabsStylesHook.useTabItem({
        bgColor: '#EF6527',
        selectedBgColor: '#ffffff',
    });

    return (
        <Toolbar
            // you need to set override hidden in toolbar
            style={{ overflow: 'hidden', minHeight: 72 }}
        >
            <Tabs
                style={{ alignSelf: 'flex-end' }}
                classes={tabsStyles}
                value={globalState.tabValue}
                onChange={(e, index) => globalDispatch({type: 'setTabValue', value: index})}
                variant="fullWidth"
            >
                <Tab
                    classes={tabItemStyles}
                    disableRipple
                    label={'Newsfeed'}
                    component={NavLink}
                    to={`/${classcode}/newsfeed`}
                />

                <Tab
                    classes={tabItemStyles}
                    disableRipple
                    label={'Classwork'}
                    component={NavLink}
                    to={`/${classcode}/classwork`}
                />

                <Tab
                    classes={tabItemStyles}
                    disableRipple
                    label={'Participants'}
                    component={NavLink}
                    to={`/${classcode}/participants`}
                />

                { authState.user.role_id !== 3 ? (
                    <Tab
                        classes={tabItemStyles}
                        disableRipple
                        label={'Grading'}
                        component={NavLink}
                        to={`/${classcode}/grading`}
                    />
                ) : null}

                {/* { authState.user.role_id !== 3 && authState.user.role_id !== 5 ? (
                    <Tab
                        classes={tabItemStyles}
                        disableRipple
                        label={'Grading'}
                        component={NavLink}
                        to={`/${classcode}/grading`}
                    />
                ) : null} */}

            </Tabs>
        </Toolbar>
    );
};

export default SerratedTabs;